//
// Copyright 2024 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/query.proto (package dxos.echo.query, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { EchoObject } from "./object_pb.js";
import { file_dxos_echo_object } from "./object_pb.js";
import { file_dxos_echo_indexing } from "./indexing_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/query.proto.
 */
export const file_dxos_echo_query: GenFile = /*@__PURE__*/
  fileDesc("ChVkeG9zL2VjaG8vcXVlcnkucHJvdG8SD2R4b3MuZWNoby5xdWVyeSJ1CgxRdWVyeVJlcXVlc3QSFAoHcXVlcnlJZBgBIAEoCUgAiAEBEjQKCnJlYWN0aXZpdHkYAyABKA4yIC5keG9zLmVjaG8ucXVlcnkuUXVlcnlSZWFjdGl2aXR5Eg0KBXF1ZXJ5GAUgASgJQgoKCF9xdWVyeUlkIhcKBUhlYWRzEg4KBmhhc2hlcxgBIAMoCSKbBAoLUXVlcnlSZXN1bHQSCgoCaWQYASABKAkSDwoHc3BhY2VJZBgEIAEoCRIXCgpkb2N1bWVudElkGAUgASgJSACIAQESFAoHcXVldWVJZBgGIAEoCUgBiAEBEhsKDnF1ZXVlTmFtZXNwYWNlGAcgASgJSAKIAQESDAoEcmFuaxgDIAEoAhIaCg1kb2N1bWVudF9qc29uGAogASgJSAOIAQESHwoSZG9jdW1lbnRfYXV0b21lcmdlGAsgASgMSASIAQESDQoFaGVhZHMYDiADKAkSEgoFYnl0ZXMYDyABKAxIBYgBARIXCgpjcmVhdGVkX2F0GBAgASgBSAaIAQESFwoKdXBkYXRlZF9hdBgRIAEoAUgHiAEBEhUKCGdyb3VwS2V5GAwgASgJSAiIAQESFwoKZ3JvdXBDb3VudBgNIAEoBUgJiAEBEisKCHNwYWNlS2V5GAIgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleUgKiAEBQg0KC19kb2N1bWVudElkQgoKCF9xdWV1ZUlkQhEKD19xdWV1ZU5hbWVzcGFjZUIQCg5fZG9jdW1lbnRfanNvbkIVChNfZG9jdW1lbnRfYXV0b21lcmdlQggKBl9ieXRlc0INCgtfY3JlYXRlZF9hdEINCgtfdXBkYXRlZF9hdEILCglfZ3JvdXBLZXlCDQoLX2dyb3VwQ291bnRCCwoJX3NwYWNlS2V5Io8BCg1RdWVyeVJlc3BvbnNlEhQKB3F1ZXJ5SWQYASABKAlIAIgBARItCgdyZXN1bHRzGAIgAygLMhwuZHhvcy5lY2hvLnF1ZXJ5LlF1ZXJ5UmVzdWx0Ei0KB29iamVjdHMYAyADKAsyHC5keG9zLmVjaG8ub2JqZWN0LkVjaG9PYmplY3RCCgoIX3F1ZXJ5SWQqLQoPUXVlcnlSZWFjdGl2aXR5EgwKCE9ORV9TSE9UEAASDAoIUkVBQ1RJVkUQAWIGcHJvdG8z", [file_google_protobuf_empty, file_dxos_keys, file_dxos_echo_object, file_dxos_echo_indexing]);

/**
 * @generated from message dxos.echo.query.QueryRequest
 */
export type QueryRequest = Message<"dxos.echo.query.QueryRequest"> & {
  /**
   * @generated from field: optional string queryId = 1;
   */
  queryId?: string;

  /**
   * @generated from field: dxos.echo.query.QueryReactivity reactivity = 3;
   */
  reactivity: QueryReactivity;

  /**
   * / JSON-encoded `QueryAST.Query`.
   *
   * @generated from field: string query = 5;
   */
  query: string;
};

/**
 * Describes the message dxos.echo.query.QueryRequest.
 * Use `create(QueryRequestSchema)` to create a new message.
 */
export const QueryRequestSchema: GenMessage<QueryRequest> = /*@__PURE__*/
  messageDesc(file_dxos_echo_query, 0);

/**
 * *
 * Automerge heads.
 * Used for encoding in Index metadata store.
 * @see https://automerge.org/automerge-repo/types/_automerge_automerge_repo.Heads.html
 *
 * @generated from message dxos.echo.query.Heads
 */
export type Heads = Message<"dxos.echo.query.Heads"> & {
  /**
   * @generated from field: repeated string hashes = 1;
   */
  hashes: string[];
};

/**
 * Describes the message dxos.echo.query.Heads.
 * Use `create(HeadsSchema)` to create a new message.
 */
export const HeadsSchema: GenMessage<Heads> = /*@__PURE__*/
  messageDesc(file_dxos_echo_query, 1);

/**
 * @generated from message dxos.echo.query.QueryResult
 */
export type QueryResult = Message<"dxos.echo.query.QueryResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string spaceId = 4;
   */
  spaceId: string;

  /**
   * @generated from field: optional string documentId = 5;
   */
  documentId?: string;

  /**
   * @generated from field: optional string queueId = 6;
   */
  queueId?: string;

  /**
   * @generated from field: optional string queueNamespace = 7;
   */
  queueNamespace?: string;

  /**
   * @generated from field: float rank = 3;
   */
  rank: number;

  /**
   * *
   * The object as `objectStructureToJson` (`@dxos/echo/internal`) writes it, which
   * `objectStructureFromJson` reads back: data fields at the top level with `Uint8Array` values
   * in the DAG-JSON form `{"/":{"bytes":…}}`, plus `id`, `@type`, `@meta` (omitted when empty), `@deleted`,
   * `@parent`, `@relationSource` and `@relationTarget`.
   *
   * @generated from field: optional string document_json = 10;
   */
  documentJson?: string;

  /**
   * @generated from field: optional bytes document_automerge = 11;
   */
  documentAutomerge?: Uint8Array;

  /**
   * / Heads of the document the index read `document_json` at; sent only for a document that holds just this object.
   *
   * @generated from field: repeated string heads = 14;
   */
  heads: string[];

  /**
   * / The document's Automerge bytes, which may be ahead of `heads`; sent with `heads` so the client can show the row unloaded and load it on the first write.
   *
   * @generated from field: optional bytes bytes = 15;
   */
  bytes?: Uint8Array;

  /**
   * / Unix ms of the object's creation, sent with `bytes`.
   *
   * @generated from field: optional double created_at = 16;
   */
  createdAt?: number;

  /**
   * / Unix ms of the object's last change, sent with `bytes`.
   *
   * @generated from field: optional double updated_at = 17;
   */
  updatedAt?: number;

  /**
   * / JSON-encoded group key (an object keyed by the aggregate's group-field names). Present iff the query has an aggregate clause.
   *
   * @generated from field: optional string groupKey = 12;
   */
  groupKey?: string;

  /**
   * / Number of records in this record's group within the result set. Present iff the query has an aggregate clause.
   *
   * @generated from field: optional int32 groupCount = 13;
   */
  groupCount?: number;

  /**
   * / @deprecated Use spaceId.
   *
   * @generated from field: optional dxos.keys.PublicKey spaceKey = 2;
   */
  spaceKey?: PublicKey;
};

/**
 * Describes the message dxos.echo.query.QueryResult.
 * Use `create(QueryResultSchema)` to create a new message.
 */
export const QueryResultSchema: GenMessage<QueryResult> = /*@__PURE__*/
  messageDesc(file_dxos_echo_query, 2);

/**
 * @generated from message dxos.echo.query.QueryResponse
 */
export type QueryResponse = Message<"dxos.echo.query.QueryResponse"> & {
  /**
   * @generated from field: optional string queryId = 1;
   */
  queryId?: string;

  /**
   * @generated from field: repeated dxos.echo.query.QueryResult results = 2;
   */
  results: QueryResult[];

  /**
   * @generated from field: repeated dxos.echo.object.EchoObject objects = 3;
   */
  objects: EchoObject[];
};

/**
 * Describes the message dxos.echo.query.QueryResponse.
 * Use `create(QueryResponseSchema)` to create a new message.
 */
export const QueryResponseSchema: GenMessage<QueryResponse> = /*@__PURE__*/
  messageDesc(file_dxos_echo_query, 3);

/**
 * @generated from enum dxos.echo.query.QueryReactivity
 */
export enum QueryReactivity {
  /**
   * / Returns a signle result.
   *
   * @generated from enum value: ONE_SHOT = 0;
   */
  ONE_SHOT = 0,

  /**
   * / Returns the initial result and then incremental reactive updates when the data source changes.
   *
   * @generated from enum value: REACTIVE = 1;
   */
  REACTIVE = 1,
}

/**
 * Describes the enum dxos.echo.query.QueryReactivity.
 */
export const QueryReactivitySchema: GenEnum<QueryReactivity> = /*@__PURE__*/
  enumDesc(file_dxos_echo_query, 0);

